import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "@ant-design/compatible";
import { Modal, Button, Input, InputNumber, Row, Col } from "antd";
import { _newLine } from '@/utils/helpers';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { createService, updateService } from "@/redux/actions/serviceActions";
import { isMobile } from "react-device-detect";
import ServiceSelect from "@/components/ServiceSelect";
import BaseSelect from "@/components/Elements/BaseSelect";
import { getServiceGroups } from '@/utils/serviceGroups';

function ServiceForm({ form, visible, currentItem, onCancel, loadData }) {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { getFieldDecorator, validateFields, resetFields } = form;

    const config = useSelector((state) => state.config || {});
    const serviceGroups = getServiceGroups(config);

    const handleClose = () => {
        resetFields();
        setIsLoading(false);
        onCancel();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateFields(async (err, values) => {
            if (!err) {
                setIsLoading(true);
                console.log(values);
                try {
                    if (currentItem) {
                        await dispatch(updateService(currentItem.id, values));
                    } else {
                        await dispatch(createService(values));
                    }
                    loadData();
                    handleClose();
                } catch (error) {
                    setIsLoading(false);
                }
            }
        });
    };

    return (
        <Modal
            visible={visible}
            title={currentItem ? "Sửa bản ghi" : "Thêm bản ghi"}
            width={isMobile ? "100%" : "50%"}
            onCancel={handleClose}
            maskClosable={false}
            footer={[
                <Button key="back" onClick={handleClose}>Huỷ</Button>,
                <Button loading={isLoading} key="submit" type="primary" onClick={handleSubmit}>
                    {currentItem ? "Cập nhật" : "Thêm mới"}
                </Button>
            ]}
        >
            {visible && (
                <Form layout='vertical' onSubmit={handleSubmit}>
                    <Row gutter={16}>
                        <Col xs={24} md={24}>
                            <Form.Item label="Tên dịch vụ">
                                {getFieldDecorator("name", {
                                    rules: [{ required: true, message: "Trường bắt buộc!" }],
                                    initialValue: currentItem?.name || ""
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Mã dịch vụ">
                                {getFieldDecorator("code", {
                                    rules: [{ required: false }],
                                    initialValue: currentItem?.code || ""
                                })(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Giá dịch vụ">
                                {getFieldDecorator('price', {
                                    rules: [
                                        {
                                            required: false,
                                            message: 'Vui lòng điền!',
                                        },
                                    ],
                                    initialValue: currentItem ? currentItem.price : ""
                                })(
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        style={{ width: '100%' }}
                                        step={100000}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item label="Parent">
                                {getFieldDecorator('parent_id', {
                                    rules: [
                                        {
                                            required: false,
                                            message: 'Vui lòng điền!',
                                        },
                                    ],
                                    initialValue: currentItem ? currentItem.parent_id : 0
                                })(
                                    <ServiceSelect />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                label="Nhóm dịch vụ"
                                extra="Phân loại dịch vụ để áp dụng chính sách hoa hồng phù hợp (ví dụ: Niềng răng, Implant, Thẩm mỹ...)."
                            >
                                {getFieldDecorator("service_group_id", {
                                    rules: [{ required: false, message: "Vui lòng chọn!" }],
                                    initialValue: currentItem?.service_group_id ?? currentItem?.service_group?.id ?? null
                                })(
                                    <BaseSelect
                                        options={serviceGroups || []}
                                        placeholder="Chọn nhóm dịch vụ"
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item label="Trạng thái">
                                {getFieldDecorator("status", {
                                    rules: [{ required: true, message: "Vui lòng chọn!" }],
                                    initialValue: currentItem?.status ?? 1
                                })(
                                    <BaseRadioList
                                        options={[
                                            { label: "Kích hoạt", value: 1 },
                                            { label: "Chưa kích hoạt", value: 0 }
                                        ]}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item label="Ghi chú">
                                {getFieldDecorator("note", {
                                    rules: [{ required: false }],
                                    initialValue: currentItem ? _newLine(currentItem.note) : ""
                                })(<Input.TextArea />)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </Modal>
    );
}

export default Form.create({ name: "ServiceForm" })(ServiceForm);
